import type { QuizzesState } from 'features/quizzes/types';

export const resetActiveQuiz = (state: QuizzesState) => {
  state.activeQuiz = {
    localSelections: {},
    launchedAt: null,
    currentQuestionIndex: 0,
  };
};
